import { useContext } from 'react';
import { DeleteModal, ModalContext } from 'dash-ui';

import {
  GetBrokersDocument,
  useDeleteBrokerMutation,
} from 'gql/generated.graphql';
import { BrokerModals } from 'pages/brokers/constants/constants';

function DeleteBrokerModal() {
  const { payload } = useContext(ModalContext);

  const [deleteUser, { loading }] = useDeleteBrokerMutation({
    refetchQueries: [GetBrokersDocument],
  });

  async function submitBrokerDelete() {
    const { brokerId } = payload;
    await deleteUser({ variables: { brokerId } });
  }

  return (
    <DeleteModal
      entity="Broker"
      name={payload?.userName}
      isLoading={loading}
      modalName={BrokerModals.DELETE_BROKER_MODAL}
      onClick={submitBrokerDelete}
    />
  );
}

export default DeleteBrokerModal;
